<template>
  <div id="crew-alert-component">

    <!-- アラート表示領域 -->
    <div class="alert-component flex w-full flex-direction--column">
      <div class="flex w-full" >
        <!-- alert tile -->
        <div 
          v-for="(alert, index) in alertList"
          :key="index" 
          class="flex h-full justify-start" 
          style="height: 128px;"
        >
          <div v-if="index < 4" class="w-full h-full alert-tile" :style="{ 'width': alertTileWidth, 'background-color': alert.alertLevel === 'WARNING' ? '#fff8e3' : '#fff0f2', }" >
            <div class="flex flex-direction--column w-full h-full justify-start items-start">
              <div class="flex w-full justify-between items-center ">
                <div class="flex h-full items-center">
                  <div class="flex justify-center items-center alert-icon" :style="{ 'background-color': alert.alertLevel === 'WARNING' ? '#ffb300' : '#e64033', }" >
                    <span class="material-icons-outlined" style="font-size: 16px;"  :style="{ color: AISEA_COLOR.WHITE }" >info</span>
                  </div>
                  <div class="aisea-text-14-700-black alert-title">
                    {{ alert.title }}
                  </div>
                </div>
                <div class="flex justify-end items-center p-1">
                  <a class="aisea-text-14-400-blue alert-link" href="#" @click.prevent="jumpFromAlert(alert.linkTo)" >
                    確認
                  </a>
                </div>
              </div>
              <div class="flex w-full aisea-text-14-400-black p-1" style="overflow-y: auto;" >
                {{ alert.msg }}
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- alertが５件以上になった時のみ使用 -->
      <div v-if="alertList.length > 4"  class="flex w-full mt-4" style="transition: height .4s linear;" :style="{ 'height': extendedAlertFlg ? '128px' : '0' }">
        <div 
          v-for="(alert, index) in alertList"
          :key="index" 
          class="flex h-full justify-start" 
          style="height: 128px;"
          :style="{ 'display': extendedAlertFlg ? 'block' : 'none' }"
        >
          <div v-if="index >= 4" class="w-full h-full alert-tile" :style="{ 'width': alertTileWidth, 'background-color': alert.alertLevel === 'WARNING' ? '#fff8e3' : '#fff0f2', }" >
            <div class="flex flex-direction--column w-full h-full justify-start items-start">
              <div class="flex w-full justify-between items-center ">
                <div class="flex h-full items-center">
                  <div class="flex justify-center items-center alert-icon" :style="{ 'background-color': alert.alertLevel === 'WARNING' ? '#ffb300' : '#e64033', }" >
                    <span class="material-icons-outlined" style="font-size: 16px;"  :style="{ color: AISEA_COLOR.WHITE }" >info</span>
                  </div>
                  <div class="aisea-text-14-700-black alert-title">
                    {{ alert.title }}
                  </div>
                </div>
                <div class="flex justify-end items-center p-1">
                  <a class="aisea-text-14-400-blue alert-link" href="#" @click.prevent="jumpFromAlert(alert.linkTo)" >
                    確認
                  </a>
                </div>
              </div>
              <div class="flex w-full aisea-text-14-400-black p-1" style="overflow-y: auto;" >
                {{ alert.msg }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- alertが５件以上になった時のみ使用 -->
      <div 
        v-if="alertList.length > 4"
        class="flex w-full justify-center items-center cursor-pointer mt-2"
        @click="extendedAlertFlg = !extendedAlertFlg"
      >
        <div class="flex items-center">
          <div class="material-icons" :class="{'alert-open': extendedAlertFlg}" >keyboard_arrow_down</div>
          {{alertList.length}}件のアラートをすべて表示
        </div>
      </div>


    </div>
  </div>
</template>

<script>

import { DeviceInfoMixin, ColorMixin } from "@/mixins";


export default {
  components: {
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      extendedAlertFlg: false,
    };
  },
  props: {
    alertList: Array,
    alertTileWidth: String,
  },
  computed: {
  },
  watch: {
    extendedAlertFlg() {
      this.$emit('resizeCard');
    },
  },
  methods: {
    jumpFromAlert(linkToObj) {
      this.$emit('jumpFromAlert', linkToObj);
    },
  },
  created() {
  },
  mounted() {
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#crew-alert-component {
  font-family: $aisea-font-family;
  color: $aisea-black;

  .alert-tile {
    border-radius: 8px;
    padding: 4px;
    margin-right: 1rem;
    box-shadow: 4px 6px 8px $aisea-light-gray;

    .alert-icon {
      width: 24px;
      height: 24px;
      margin: 0.2rem;
      border-radius: 6px;
    }
    .alert-title {
      margin-left: 2px;
      white-space: nowrap;
    }
    .alert-link {
      white-space: nowrap;
      &:hover {
        color: $aisea-blue;
      }
    }
  }
  .alert-open {
    transform: rotateZ(-180deg);
  }

}

</style>
